module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image26.39d20a12.jpg";